import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from '@mui/material';

interface TableData {
  type: string;
  transactionCount: number;
  amount: string;
  percentage: string;
}

interface ChartTableProps {
  data: TableData[];
  title?: string;
}

export const ChartTable: React.FC<ChartTableProps> = ({ data, title }) => {
  const theme = useTheme();
  const total = {
    transactionCount: data.reduce((sum, row) => sum + row.transactionCount, 0),
    amount: data
      .reduce((sum, row) => sum + parseFloat(row.amount.replace(/[₹,]/g, '')), 0)
      .toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 2,
      }),
  };

  return (
    <Box sx={{ mt: -10, p: 2 }}>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: theme.palette.action.hover }}>
              <TableCell
                sx={{
                  fontWeight: 500,
                  fontSize: '0.875rem',
                  padding: '16px',
                  borderBottom: `1px solid ${theme.palette.divider}`,
                }}
              >
                {title || 'Payment Type'}
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  fontWeight: 500,
                  fontSize: '0.875rem',
                  padding: '16px',
                  borderBottom: `1px solid ${theme.palette.divider}`,
                }}
              >
                Transaction Count
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  fontWeight: 500,
                  fontSize: '0.875rem',
                  padding: '16px',
                  borderBottom: `1px solid ${theme.palette.divider}`,
                }}
              >
                Amount
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  fontWeight: 500,
                  fontSize: '0.875rem',
                  padding: '16px',
                  borderBottom: `1px solid ${theme.palette.divider}`,
                }}
              >
                Percentage
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <TableRow
                key={row.type}
                sx={{
                  '&:not(:last-child) td': {
                    borderBottom: `1px dashed ${theme.palette.divider}`,
                  },
                }}
              >
                <TableCell sx={{ padding: '16px' }}>{row.type}</TableCell>
                <TableCell align="right" sx={{ padding: '16px' }}>
                  {row.transactionCount.toLocaleString()}
                </TableCell>
                <TableCell align="right" sx={{ padding: '16px' }}>
                  {row.amount}
                </TableCell>
                <TableCell align="right" sx={{ padding: '16px' }}>
                  {row.percentage}
                </TableCell>
              </TableRow>
            ))}
            <TableRow
              sx={{
                backgroundColor: theme.palette.action.hover,
                '& td': {
                  fontWeight: 500,
                  padding: '16px',
                  borderTop: `1px solid ${theme.palette.divider}`,
                },
              }}
            >
              <TableCell>Total</TableCell>
              <TableCell align="right">{total.transactionCount.toLocaleString()}</TableCell>
              <TableCell align="right">{total.amount}</TableCell>
              <TableCell align="right">100%</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
